import { render } from "./VUEPopupWarning.vue?vue&type=template&id=078d7e49"
import script from "./VUEPopupWarning.vue?vue&type=script&lang=js"
export * from "./VUEPopupWarning.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__